import React, {useState } from "react";
import styled from "styled-components";
import leftsideimg from "../../images/homesectionimages/leftsideimage.png"
import rightsideimg from "../../images/homesectionimages/rightsideimage.png"

// section wrapper

const SectionWrapper = styled.div`
  display: flex;
  min-height: 100vh;
  background-color: #b65858;
  width: 100%;
  margin-top: 90px;

  @media (max-width: 768px) {
	flex-direction: column;
  }
`;

const SideBase = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px;
  color: white;
  position: relative;
`;

const LeftSide = styled(SideBase)`
  transition: background-color 0.3s ease;

  &::before {
    content: "";
    background-image: url(${leftsideimg});
    background-size: cover;
    background-position: center;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    opacity: 0;
    transition: opacity 0.3 ease;
  }

  button {
    border-radius: 50px;
    background: rgba(0, 0, 0, 0.65);
    cursor: pointer;
    width: 110px;
    height: 30px;
    color: white;
    opacity: 0;
    margin-bottom: 5%;
    transform: translatex(-100%);
    transition: opacity 0.3s ease, transform 0.3s ease;
  }

  &:hover {
    background-color: rgba(255, 255, 255, 0.2);
    &::before {
      opacity: 1;
    }
    button {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @media (max-width: 768px) {
	order: 1;
  height: 650px;

	button {
		height: 28px;
	}
  }
`;

const LeftSideContent = styled(SideBase)`
	display: flex;
	flex-direction: column;
	justify-content: center; 
	align-items: center;
	max-height: ${(props) => (props.hovered ? "50%" : "20%")};
	width: 100%;
	overflow: hidden;
	transition: max-height 0.3s ease-in-out, max-width 0.3s ease-in-out;;

	background: linear-gradient(
		90deg,
		rgba(255, 255, 255, 0.00) 7.92%,
		rgba(255, 255, 255, 0.15) 48.61%,
		rgba(255, 255, 255, 0.00) 89.31%
	);
	
  h1 {
    color: white;
    font-size: 30px;
    font-weight: 600;
    font-family: sunflower;
    padding: 10px 20px;
    text-align: center;
    margin: 0;
    opacity: 1;
    position: absolute;
  }
	
  h3 {
    color: white;
    font-size: 18px;
    font-weight: 400;
    font-family: sunflower;
    line-height: 22px;
    opacity: 0;
    transform: translateY(-20px);
    transition: opacity 0.3s ease, transform 0.3s ease;
    text-align: center;
    margin-bottom: 25%;
  }

  ${LeftSide}:hover & {
    h1 {
      margin-top: 4%;
    }
    h3, button {
      opacity: 1;
      transform: translateY(0);
    }

    &:hover{
    max-height: ${(props) => (props.hovered ? "50%" : "20%")};
    }

    @media (max-width: 768px){ 
    a {
      margin-top: 15%;
    }
  }
  }

`;

const RightSide = styled(SideBase)`
  flex: 1;
  background-color: white;
  transition: background-color 0.3s ease;

  &::before {
    content: "";
    background-image: url(${rightsideimg});
    background-size: cover;
    background-position: center;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    opacity: 0;
    transition: opacity 0.3 ease;
  }

  button {
    border-radius: 50px;
    background: rgba(0, 0, 0, 0.65);
    cursor: pointer;
    width: 110px;
    height: 30px;
    color: white;
    opacity: 0;
    margin-bottom: 5%;
    transform: translatex(100%);
    transition: opacity 0.3s ease, transform 0.3s ease;
  }

  &:hover {
    background-color: lightgray 50%;
    &::before {
      opacity: 1;
    }
    button {
      opacity: 1;
      transform: translateY(0);
    }
  }
  @media screen and (max-width: 768px) {
	order: 2;
  height: 650px;
	
	button {
		height: 28px;
	}
  
  }
`;

const RightSideContent = styled(SideBase)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-height: ${(props) => (props.hovered ? "50%" : "20%")};
  overflow: hidden;
  transition: max-height 0.3s ease-in-out, max-width 0.3s ease-in-out;
  width: 100%;

  background: linear-gradient(
    90deg,
    rgba(204, 65, 65, 0) 8.06%,
    rgba(204, 65, 65, 0.15) 49.65%,
    rgba(204, 65, 65, 0) 91.25%
  );

  h1 {
    color: #9d2222;
    font-size: 30px;
    font-weight: 600;
    font-family: sunflower;
    padding: 10px 20px;
    text-align: center;
    margin: 0;
    opacity: 1;
    position: absolute;
  }

  h3 {
    color: #9d2222;
    font-size: 18px;
    font-weight: 400;
    font-family: sunflower;
    line-height: 22px;
    opacity: 0;
    transform: translateY(-20px);
    transition: opacity 0.3s ease, transform 0.3s ease;
    text-align: center;
    margin-bottom: 25%;
  }

  ${RightSide}:hover & {
    h1 {
      margin-top: 4%;
    }

    h3,
    button {
      opacity: 1;
      transform: translateX(0);
    }

    &:hover {
      max-height: ${(props) => (props.hovered ? "50%" : "20%")};
    }
  }
  
  @media screen and (max-width: 768px){ 

    a {
      margin-top: 15%;
    }
  }

`;

export function TopSection() {
	const [leftHovered, setLeftHovered] = useState(false);
	const [rightHovered, setRightHovered] = useState(false);
	
	return(
		<SectionWrapper>
			<LeftSide onMouseEnter={() => setLeftHovered(true)} onMouseLeave={() => setLeftHovered(false)}>
				<LeftSideContent id="left-content"hovered={leftHovered}>
					<h3>From IT to Call Centers, <br /> we've got you covered.</h3>
					<h1>STAFF YOUR <br/>WORKFORCE</h1>
          <a href="/staffing">
					  <button>Let's Go!</button>
          </a>
				</LeftSideContent>
			</LeftSide>
			<RightSide onMouseEnter={() => setRightHovered(true)} onMouseLeave={() => setRightHovered(false)}>
				<RightSideContent hovered={rightHovered}>
					<h3>Looking for work? <br /> Look no further.</h3>
					<h1>SPARK YOUR <br /> CAREER</h1>
          <a href="/careers">
					  <button>Let's Go!</button>
          </a>
				</RightSideContent>
			</RightSide>
		</SectionWrapper>
	)
}